<template>
  <tr
    :class="{ 'boss-table-4-selected': !entryObject.entry.isRead }"
    data-test="tr-show"
  >
    <td
      class="boss-center pega-input"
      data-test="check"
      @click="entryObject.isChecked = !entryObject.isChecked; updateChecked();"
    >
      <input
        data-role="select-user"
        type="checkbox"
        class="boss-input-checkbox"
        :checked="entryObject.isChecked"
      >
    </td>
    <td
      class="boss-center boss-table-4-link-cell"
    >
      <router-link
        :to="{ name: 'seminarEntryDetail', params: { entryId: entryObject.entry.id, tabKey: 'resume' } }"
        data-test="date"
        class="boss-table-4-link"
      >
        {{ entryDate }}
        <div data-test="time">
          {{ entryTime }}
        </div>
      </router-link>
    </td>
    <td class="boss-center">
      <router-link
        :to="{ name: 'seminarEntryDetail', params: { entryId: entryObject.entry.id, tabKey: 'resume' } }"
        data-test="user-id"
        class="boss-table-4-link boss-table-4-link-has-mark"
      >
        ID:{{ entryObject.entry.userId }}
        <span
          v-if="entryObject.entry.isWithdrawal"
          data-test="withdrawal"
        >（途中退会）</span>
        <span v-if="entryObject.entry.isDuplicatedEntries"><br><span
          v-tooltip="{ content: '同一セミナーに複数回応募している場合に表示されます。', trigger: 'hover' }"
          class="boss-status-label"
          data-test="duplicate"
        >重複応募</span></span>
        <div data-test="member-name">
          {{ memberName }}
        </div>
      </router-link>
    </td>
    <td>
      <router-link
        :to="{ name: 'seminarEntryDetail', params: { entryId: entryObject.entry.id, tabKey: 'resume' } }"
        data-test="seminar-id"
        class="boss-table-4-link"
      >
        セミナーID:{{ entryObject.entry.seminar.id }}
        <div
          data-test="seminar-name"
          class="pega-white-space-normal"
        >
          {{ entryObject.entry.seminar.name }}
        </div>
      </router-link>
    </td>
    <message-icon-information
      :message="entryObject.entry.message"
      :entry-id="entryObject.entry.id"
      :is-entry="false"
    />
    <td>
      <select
        v-model="entryObject.entry.statusId"
        class="boss-input-select js-check-default"
        data-default
        data-test="status"
        @change="updateStatus"
      >
        <option :value="null">
          −
        </option>
        <option
          v-for="(status ,i) in seminarStatuses"
          :key="i"
          :value="status.id"
        >
          {{ status.name }}
        </option>
      </select>
    </td>
    <td
      class="boss-table-cell-has-textarea pega-position-inherit"
      data-test="remarks"
    >
      <textarea
        v-model="entryObject.entry.remarks"
        class="boss-textarea-in-table"
        rows="5"
        data-test="text-remarks"
        @change="updateRemarks"
      />
    </td>
  </tr>
</template>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import cartInAnimation from '@/lib/cartInAnimation'
import MessageIconInformation from '@/components/atoms/MessageIconInformation'

export default {
  components: {
    MessageIconInformation
  },
  props: {
    entryObject: {
      type: Object,
      required: true
    },
    displayTarget: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      seminarStatuses: 'seminarStatuses'
    }),
    entryDate () {
      return dayjs(_.get(this.entryObject, 'entry.entryDate')).format('YY/MM/DD')
    },
    entryTime () {
      return dayjs(_.get(this.entryObject, 'entry.entryDate')).format('HH:mm')
    },
    memberName () {
      return this.entryObject.entry.userLastName + this.entryObject.entry.userFirstName
    }
  },
  methods: {
    updateChecked () {
      this.$emit('update-checked', {
        id: this.entryObject.entry.id,
        isChecked: this.entryObject.isChecked
      })
    },
    updateRemarks () {
      this.$http.secured.put('/seminar/entries/remarks',
        {
          entryIds: [this.entryObject.entry.id],
          remarks: this.entryObject.entry.remarks
        }
      ).then(() => {
        this.$toasted.global.successRightTopSingleton({ message: '備考を更新しました。' })
      })
    },
    updateStatus () {
      this.$http.secured.put('/seminar/entries/status',
        {
          entryIds: [this.entryObject.entry.id],
          statusId: this.entryObject.entry.statusId
        }
      ).then(() => {
        const targetElementId = this.entryObject.entry.statusId === 5 // 5:終了ステータス
          ? `#display-target-${this.entryObject.entry.statusId}` : ''
        this.$toasted.global.successRightTopSingleton(
          {
            message: `ステータスを更新しました。${targetElementId ? '<br>画面右上の「終了」ボタンをONにした場合のみ表示されます。' : ''}`
          }
        )
        targetElementId && cartInAnimation.start(_.includes(this.displayTarget, this.entryObject.entry.statusId) ? this.$el : '#entry-entries', targetElementId)
      })
    }
  }
}
</script>
